<template>
    <uw-content title="商机" padding="10px">
        <template slot="prefix">
            <el-button size="mini" :type="search.state == null ? 'primary' : 'text'" @click="search.state = null; TableSearch()">全部</el-button>
            <el-button size="mini" :type="search.state == 1 ? 'primary' : 'text'" @click="search.state = 1; TableSearch()">跟进</el-button>
            <el-button size="mini" :type="search.state == 2 ? 'primary' : 'text'" @click="search.state = 2; TableSearch()">成功</el-button>
            <el-button size="mini" :type="search.state == 4 ? 'warning' : 'text'" @click="search.state = 4; TableSearch()">搁置</el-button>
            <el-button size="mini" :type="search.state == 3 ? 'danger' : 'text'" @click="search.state = 3; TableSearch()">失败</el-button>
            <el-button size="mini" :type="search.state == 0 ? 'danger' : 'text'" @click="search.state = 0; TableSearch()">放弃</el-button>
        </template>
        <div :style="{ height: '100%', display: 'flex', flexDirection: 'column' }">
            <uw-grid-search gutter="0 10px" :column="3" :style="{ marginBottom: '10px' }">
                <template slot="full">
                    <el-input v-model="search.name" @input="$lodash.debounce(TableSearch, 500)" clearable placeholder="商机名称" />
                </template>
                <template slot="tools">
                    <el-button type="primary" @click="$refs.drawerCreate.Open()">新建商机</el-button>
                    <el-button type="primary" size="mini" @click="$refs.xTable.print()" >打印</el-button>
                    <el-button type="primary" size="mini" @click="$refs.xTable.openExport()" >导出</el-button>
                </template>
                <el-form-item label="销售">
                    <users-select v-model="search.users_sale_ids" @onChange="TableSearch" multiple placeholder="销售查询" />
                </el-form-item>
                <el-form-item label="售前">
                    <users-select v-model="search.users_presale_ids" @onChange="TableSearch" multiple placeholder="售前查询" />
                </el-form-item>
                <el-form-item label="商务">
                    <users-select v-model="search.users_affair_ids" @onChange="TableSearch" multiple placeholder="商务查询" />
                </el-form-item>
                <el-form-item label="管理员">
                    <users-select v-model="search.users_admin_ids" @onChange="TableSearch" multiple placeholder="管理员查询" />
                </el-form-item>
                <el-form-item label="跟进日期">
                    <el-date-picker @change="TableSearch" v-model="search.updated_at" clearable type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :style="{ width: '100%' }"></el-date-picker>
                </el-form-item>
                <el-form-item label="创建日期">
                    <el-date-picker @change="TableSearch" v-model="search.created_at" clearable type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :style="{ width: '100%' }"></el-date-picker>
                </el-form-item>
            </uw-grid-search>
            <div :style="{ flex: '1 0 0', height: '0' }">
                <vxe-table
                    ref="xTable"
                    :data="table"
                    :loading="loading"
                    :export-config="{}"
                    :print-config="{}"
                    :seq-config="{startIndex: page.size * (page.current - 1)}"
                    @sort-change="TableSort"
                    height="100%">
                    <vxe-column width="60" type="seq" title="序号"></vxe-column>
                    <vxe-column min-width="80" field="state" title="跟单状态">
                        <template #default="{ row }">
                            <el-tag size="mini" effect="dark" v-if="row.state == 0" type="danger">放弃</el-tag>
                            <el-tag size="mini" effect="dark" v-if="row.state == 1" type="primary">跟进</el-tag>
                            <el-tag size="mini" effect="dark" v-if="row.state == 2" type="success">成功</el-tag>
                            <el-tag size="mini" effect="dark" v-if="row.state == 3" type="danger">失败</el-tag>
                            <el-tag size="mini" effect="dark" v-if="row.state == 4" type="warning">搁置</el-tag>
                        </template>
                    </vxe-column>
                    <vxe-column min-width="210" field="name" title="跟单主题" sortable>
                        <template #default="{ row }">
                            <el-link type="primary" @click="$refs.drawerDrawer.Open(row.id)" :icon="row.files_id.length > 0 ? 'el-icon-paperclip' : ''">{{ row.name }}</el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="210" field="customer_id" title="关联客户" sortable>
                        <template #default="{ row }">
                            <el-link type="primary" v-if="row.customer"  icon="el-icon-office-building" @click="$refs.customerDrawer.Open(row.customer.id)">{{ row.customer.name }}</el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="120" field="sign_money" title="预期金额" sortable>
                        <template #default="{ row }">
                            ￥{{ row.sign_money.toLocaleString() }}
                        </template>
                    </vxe-column>
                    <vxe-column min-width="240" field="progress_id" title="工作进度">
                        <template #default="{ row }">
                            <el-tag size="mini" class="w-margin-r-5" v-for="(item, idx) in row.progress.filter(v => v.value > 0)" :key="idx">{{ item.title }}</el-tag>
                        </template>
                    </vxe-column>
                    <vxe-column width="90" field="user_sale_id" title="销售" sortable>
                        <template #default="{ row }">
                            <el-link icon="el-icon-user" :underline="false">{{ row.user_sale.name }}</el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="90" field="user_affair_id" title="商务" sortable>
                        <template #default="{ row }">
                            <el-link icon="el-icon-user" :underline="false">{{ row.user_affair.name }}</el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="90" field="user_presale_id" title="售前" sortable>
                        <template #default="{ row }">
                            <el-link icon="el-icon-user" :underline="false">{{ row.user_presale.name }}</el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="90" field="user_admin_id" title="管理员">
                        <template #default="{ row }">
                            <el-link icon="el-icon-user" :underline="false">{{ row.user_admin.name }}</el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="140" field="updated_at" title="跟进时间" sortable></vxe-column>
                    <vxe-column width="45" title="操作" fixed="right" align="center">
                        <template #default="{ row }">
                            <el-dropdown trigger="click">
                                <el-link icon="el-icon-more" type="primary" :underline="false"></el-link>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native.stop="TableUpdateState(row.id, 1)">
                                        <el-link type="primary" :underline="false">跟进</el-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native.stop="TableUpdateState(row.id, 4)">
                                        <el-link type="warning" :underline="false">搁置</el-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native.stop="TableUpdateState(row.id, 3)">
                                        <el-link type="danger" :underline="false">失败</el-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native.stop="TableUpdateState(row.id, 0)">
                                        <el-link type="danger" :underline="false">放弃</el-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native.stop="$refs.drawerUpdate.Open(row.id)" divided>
                                        <el-link type="primary" :underline="false">跟进/编辑</el-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native.stop="TableDelete(row.id)" divided>
                                        <el-link type="danger" :underline="false">删除</el-link>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </vxe-column>
                </vxe-table>
            </div>
            <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
        </div>
        <crm-business-create ref="drawerCreate" @success="TableSearch" />
        <crm-business-update ref="drawerUpdate" @success="TableSearch" />
        <crm-business-drawer ref="drawerDrawer" @onChange="TableSearch" />
        <crm-customer-drawer ref="customerDrawer"/>
    </uw-content>
</template>
<script>
export default {
    data () {
        return {
            loading: false,
            table: [],
                        page: {
                total: 0,
                size: 50,
                current: 1,
            },
                        search: {
                name: null,
                state: null,
                users_sale_ids: null,
                users_presale_ids: null,
                users_affair_ids: null,
                users_admin_ids: null,
                updated_at: [],
                created_at: []
            },
                        order: {
                method: 'desc',
                column: 'id'
            },
        }
    },
    mounted () {
        this.TableSearch()
    },
    methods: {
        TableSearch() {
            this.loading = true
            this.$http.post(
                '/9api/crm/business/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    append: ['customer', 'user_sale', 'user_admin', 'user_affair', 'user_presale'],
                    hidden: ['describe']
                }
            ).then((rps) => {
                                this.page.total = rps.data.total
                this.table = rps.data.body
                                if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }
                                this.loading = false
            })
        },
        TableSort(column) {
            this.order.method = column.order ? column.order : this.order.method
            this.order.column = column.field
            this.TableSearch()
        },
        TableDelete(id) {
            this.loading = true
            this.$http.post('/9api/sale-documentary/delete', { id: id }).then((rps) => {
                this.TableSearch()
            })
        },
        TableUpdateState(id, state) {
            this.loading = true
            this.$http.post('/9api/sale-documentary/update-state', { id: id, state: state }).then((rps) => {
                this.TableSearch()
            })
        }
    }
}
</script>